module.exports = new __parcel__URL__("jsm-incident-management.dd18be0a.svg").toString();